// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zwZPwzHMcj8EiwONmXBo{position:absolute;top:0;left:0;right:0;bottom:0;text-align:center;vertical-align:center;display:table-cell}.zwZPwzHMcj8EiwONmXBo svg{width:100%;height:100%;max-width:100%;max-height:100%}.zwZPwzHMcj8EiwONmXBo .item{cursor:pointer}.zwZPwzHMcj8EiwONmXBo .item *{transition:fill ease-in .2s}.zwZPwzHMcj8EiwONmXBo .item:hover *:not(.text){stroke:var(--color-primary) !important;stroke-width:1px}.zwZPwzHMcj8EiwONmXBo .item.active *:not(.text){fill:var(--color-primary) !important;stroke:var(--color-primary) !important;stroke-width:1px}.zwZPwzHMcj8EiwONmXBo .item.active .text{fill:var(--color-white)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `zwZPwzHMcj8EiwONmXBo`
};
export default ___CSS_LOADER_EXPORT___;
